import { name } from '../../package.json'
const { SimpleErrorReport } = require('@nrk/dh-simple-error-report')

export type SendError = (message: string) => void

export function createErrorReporter(name: string, isErrorReportingEnabled: boolean) {
  return new SimpleErrorReport({
    name: name,
    url: `https://dh.nrk.no/catch`,
    dryRun: !isErrorReportingEnabled
  })
}

function _toMessageObject(error) {
  const { message, filename: url, lineno: line, colno: column } = error
  const messageObj = { message } as any
  if (url !== '') {
    messageObj.url = url
  }
  if (line > 0) {
    messageObj.line = line
  }
  if (column > 0) {
    messageObj.column = column
  }
  if (error.stack) {
    messageObj.stack = error.stack
  }
  return messageObj
}

export async function convertToMessageObject(error) {
  if (error.stacktrace || error.stack) {
    try {
      const stacktraceJs = await import('stacktrace-js' /* webpackChunkName: "stacktrace-js" */)
      const StackTrace = stacktraceJs.default

      const stackframes = await StackTrace.fromError(error)
      const stack = stackframes.map(stackframe => stackframe.toString()).join('\n')
      return { message: error.message, stack }
    } catch (e) {
      return _toMessageObject(error)
    }
  } else {
    return _toMessageObject(error)
  }
}

export function initializeErrorReporting(el: Element): { sendError: SendError } {
  const errorTrackingEnabled = el.getAttribute('data-error-tracking-enabled') === 'true'

  const simpleErrorReport = createErrorReporter(name || '', errorTrackingEnabled)
  simpleErrorReport.listenAndCatch()

  const sendError = (error: any) => {
    if (typeof error === 'string') {
      simpleErrorReport.sendErrorReport({ message: error })
    } else {
      convertToMessageObject(error).then(messageObj => {
        simpleErrorReport.sendErrorReport(messageObj)
      })
    }
  }

  return { sendError }
}
